import Cookies from 'js-cookie'
import uniq from 'lodash/uniq'

const KNOWN_DOMAINS = [
  'localhost',
  'www.researchaffiliates.com',
  '.researchaffiliates.com',
  'www.rafi.com',
  '.rafi.com',
  '.addthis.com',
  '.2o7.net',
  'omtrdc.net',
  '.demdex.net',
  '.everesttech.net',
  'dpm.demdex.net',
  '.vimeo.com'
]

const KNOWN_COOKIES = [
  '__atuvc',
  '__atuvs',
  '_cfuid',
  '_ga',
  '_sdsat_accountType',
  '_sdsat_country',
  '_sdsat_loginStatus',
  '_tmae',
  '_utma',
  '_utmz',
  'AWSELB',
  'compType',
  'continuous_play_v3',
  'currentArticleIdx',
  'currentSearchStart',
  'cw_id',
  'demdex',
  'dextp',
  'DisclaimerClosed',
  'dpm',
  'DST',
  'ev_sync_ox',
  'ev_sync_yh',
  'everest_g_v2',
  'everest_session_v2',
  'gglck',
  'gpv_pn',
  'loc',
  'mus',
  'na_id',
  'na_tc',
  'player',
  'resultLimit',
  'resultTotalRecords',
  's_cc',
  's_getNewRepeat',
  's_ppv',
  's_ppvl',
  's_sq',
  's_vi',
  'searchPgUrl',
  'searchQry',
  'ssc',
  'uid',
  'uvc',
  'vuid',
  'webid'
]

/**
 * Uses brute force to attempt to remove as many cookies as possible.
 */
export function clear() {
  let cookies = uniq(Object.keys(Cookies.get()).concat(KNOWN_COOKIES))

  cookies.map(cookie => {
    remove(cookie)
    remove(cookie, {
      secure: true
    })

    KNOWN_DOMAINS.map(domain => {
      remove(cookie, {
        domain
      })
      remove(cookie, {
        domain,
        secure: true
      })
    })
  })
}

/**
 * Removes a cookie.
 *
 * @param {String} name
 * @param {Object} options
 */
export function remove(name, options) {
  options ? Cookies.remove(name, options) : Cookies.remove(name)
}

export default {
  remove,
  clear
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/cookies.js